export class CouponClaimHistoryFilter {
    claimedDate: string;
    couponCode: string;
    productId: string;
    status: string;

     

}